import { Skeleton } from '@nexelem/components';
import { useCustomTranslation } from '../../../../../hooks';
import { HistoricalParallelMachinePairsMatrix } from './HistoricalParallelMachinePairsMatrix';
import { useHistoricalParallelMachinePairs } from './useHistoricalParallelMachinePairs';

export type HistoricalParallelMachinePairsMatrixModalContentProps = {
  machineAreaId: number;
  lookbackMonths: number;
  minOverlapsForPairPerMonth: number;
};

export const HistoricalParallelMachinePairsMatrixModalContent = ({
  machineAreaId,
  lookbackMonths,
  minOverlapsForPairPerMonth,
}: HistoricalParallelMachinePairsMatrixModalContentProps) => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.autoAssigment');
  const { data, isLoading, isError } = useHistoricalParallelMachinePairs({
    machineAreaId,
    lookbackMonths,
    minOverlapsForPairPerMonth,
  });

  if (isLoading) {
    return (
      <div className="flex h-full flex-col gap-2">
        <Skeleton className="h-12" />
        <Skeleton className="h-full" />
      </div>
    );
  }

  if (isError || !data) {
    return (
      <p className="my-4 text-center text-t14-sb text-text-state-error-light">
        {tWrapper('policy.parallelPairs.loadError')}
      </p>
    );
  }

  if (!data.machines.length) {
    return <p className="my-4 text-center text-t14-sb text-text-secondary">{tWrapper('policy.parallelPairs.empty')}</p>;
  }

  return <HistoricalParallelMachinePairsMatrix {...data} />;
};
